import { Component, Output, EventEmitter } from "@angular/core";

@Component({
    template: '',
    standalone: false
})
export abstract class LeadHistoryAuditItemBase {
    @Output() selected = new EventEmitter()
    @Output() unselected = new EventEmitter()

    isSelected: boolean = false

    constructor() {
        this.selected.subscribe(() => this.isSelected = true)
        this.unselected.subscribe(() => this.isSelected = false)
    }
}